// Enter speichert, Escape bricht ab — in Dialogen und in der gerade offenen Bearbeitung.
// Ein Feld, das Enter selbst verbraucht (Suche, Vorschlagsliste), ruft preventDefault auf
// und behält damit Vorrang. Mehrzeilige Felder fügen mit Enter eine Zeile ein.

const ACTION_SELECTOR = 'button, [role="button"], input[type="submit"], input[type="button"]';

let installed = false;

function labelOf(el) {
  const aria = (el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
  if (aria) return aria;
  const text = (el.textContent || el.value || '').replace(/\s+/g, ' ').trim();
  if (text) return text;
  return (el.getAttribute('title') || '').replace(/\s+/g, ' ').trim();
}

function isSaveLabel(text) {
  if (!text || /&\s*neu\b/i.test(text)) return false;
  return /speichern$/i.test(text) || /^anlegen$/i.test(text);
}

function isCancelLabel(text) {
  return /^(abbrechen|abbruch)$/i.test(text);
}

function isActionable(el) {
  if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
  if (el.closest('[hidden]')) return false;
  let node = el;
  while (node && node.nodeType === 1) {
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    node = node.parentElement;
  }
  return true;
}

function matchingActions(root, match) {
  if (!root || !root.querySelectorAll) return [];
  return [...root.querySelectorAll(ACTION_SELECTOR)].filter((el) => match(labelOf(el)) && isActionable(el));
}

function findSurface(target) {
  if (!target || !target.closest) return null;
  const dialog = target.closest('[role="dialog"], [role="alertdialog"]');
  if (dialog) return dialog;
  let node = target.parentElement;
  while (node && node !== document.documentElement) {
    const saves = matchingActions(node, isSaveLabel);
    const cancels = matchingActions(node, isCancelLabel);
    if (saves.length > 1) return null;
    if (saves.length === 1 && cancels.length >= 1) return node;
    node = node.parentElement;
  }
  return null;
}

function floatingLayerOpen() {
  return Boolean(document.querySelector(
    '[data-radix-popper-content-wrapper], [role="listbox"], [role="menu"]',
  ));
}

function formSubmitsOnEnter(target) {
  if (!target || !target.closest) return false;
  if (target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
  const form = target.closest('form');
  if (!form || !form.contains(target)) return false;
  return Boolean(form.querySelector('button[type="submit"], input[type="submit"]'));
}

function enterStaysInField(target) {
  if (!target || target.nodeType !== 1) return true;
  const tag = target.tagName;
  if (tag === 'TEXTAREA' || target.isContentEditable) return true;
  if (tag === 'BUTTON' || tag === 'A' || target.getAttribute('role') === 'button') return true;
  if (target.closest('[role="listbox"], [role="menu"], [role="option"]')) return true;
  if (target.getAttribute('aria-expanded') === 'true') return true;
  if (formSubmitsOnEnter(target)) return true;
  return false;
}

function activateSave(target) {
  if (floatingLayerOpen() || enterStaysInField(target)) return;
  const surface = findSurface(target);
  if (!surface) return;
  const saves = matchingActions(surface, isSaveLabel);
  if (saves.length !== 1) return;
  saves[0].click();
}

function activateCancel(target) {
  if (!target || !target.closest || floatingLayerOpen()) return;
  const surface = findSurface(target);
  if (!surface) return;
  const cancels = matchingActions(surface, isCancelLabel);
  if (!cancels.length) return;
  cancels[cancels.length - 1].click();
}

function onKeyDown(event) {
  if (event.defaultPrevented || event.repeat || event.isComposing) return;
  if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) return;
  if (event.key !== 'Enter' && event.key !== 'Escape') return;
  const key = event.key;
  const target = event.target;
  queueMicrotask(() => {
    if (event.defaultPrevented) return;
    if (key === 'Enter') activateSave(target);
    else activateCancel(target);
  });
}

export function installSaveCancelShortcuts() {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener('keydown', onKeyDown);
}
